/*
 * By Silvana Ramirez | AUGUST 2018
 * Notes: AT THE END -> EVENT LISTENERS
 */

// Func = limiting Scope for this file

var sub = 1

;(function () {

	let content_intro_in = document.querySelectorAll( ".content__intro__in > p > a" )
	if( content_intro_in ){
		
		[...content_intro_in].forEach( ( item, index ) => {

			item.addEventListener( "click", ( e ) => {
				
				let div = document.querySelector( "#" + item.href.split( "#" )[1] )
				if( div ){
					e.preventDefault();
					let pos = div.offsetTop;
					window.scrollTo(0, pos  + 400)
				}	

			} )

		} )

	}

	//Translate datepicker
	$.datepicker.regional['es'] = {
		monthNames: [
			'Enero',
			'Febrero',
			'Marzo',
			'Abril',
			'Mayo',
			'Junio',
			'Julio',
			'Agosto',
			'Septiembre',
			'Octubre',
			'Noviembre',
			'Diciembre',
		],
		monthNamesShort: [
			'Ene',
			'Feb',
			'Mar',
			'Abr',
			'May',
			'Jun',
			'Jul',
			'Ago',
			'Sep',
			'Oct',
			'Nov',
			'Dic',
		],
		dayNames: [
			'Domingo',
			'Lunes',
			'Martes',
			'Miercoles',
			'Jueves',
			'Viernes',
			'Sabado',
		],
		dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
		dayNamesMin: ['Do', 'Lu', 'Ma', 'Mc', 'Ju', 'Vi', 'Sa'],
	}
	$.datepicker.regional['fr'] = {
		monthNames: [
			'Janvier',
			'Février',
			'Mars',
			'Avril',
			'Mai',
			'Juin',
			'Juillet',
			'Août',
			'Septembre',
			'Octobre',
			'Novembre',
			'Décembre',
		],
		monthNamesShort: [
			'Jan',
			'Fev',
			'Mar',
			'Avr',
			'Mai',
			'Jui',
			'Jui',
			'Aoû',
			'Sep',
			'Oct',
			'Nov',
			'Dec',
		],
		dayNames: [
			'Dimanche',
			'Lundi',
			'Mardi',
			'Mercredi',
			'Jeudi',
			'Vendredi',
			'Samedi',
		],
		dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
		dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
	}
	$.datepicker.regional['pt'] = {
		monthNames: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		monthNamesShort: [
			'Jan',
			'Fev',
			'Mar',
			'Abr',
			'Mai',
			'Jun',
			'Jul',
			'Ago',
			'Set',
			'Out',
			'Nov',
			'Dez',
		],
		dayNames: [
			'Domingo',
			'Segunda',
			'Terça',
			'Quarta',
			'Quinta',
			'Sexta',
			'Sabado',
		],
		dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
		dayNamesMin: ['Do', 'Se', 'Te', 'Qa', 'Qi', 'Se', 'Sa'],
	}
	$.datepicker.regional['nl'] = {
		monthNames: [
			'Januari',
			'Februari',
			'Maart',
			'April',
			'Mei',
			'Juni',
			'Juli',
			'Augustus',
			'September',
			'Oktober',
			'November',
			'December',
		],
		monthNamesShort: [
			'Jan',
			'Feb',
			'Maa',
			'Apr',
			'Mei',
			'Jun',
			'Jul',
			'Aug',
			'Sep',
			'Okt',
			'Nov',
			'Dec',
		],
		dayNames: [
			'Zondag',
			'Maandag',
			'Dinsdag',
			'Woensdag',
			'Donderdag',
			'Vrijdag',
			'Zaterdag',
		],
		dayNamesShort: ['Zon', 'Maa', 'Din', 'Woe', 'Don', 'Vri', 'Zat'],
		dayNamesMin: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
	}
	$.datepicker.regional['it'] = {
		monthNames: [
			'Gennaio',
			'Febbraio',
			'Marzo',
			'Aprile',
			'Maggio',
			'Giugno',
			'Luglio',
			'Agosto',
			'Settembre',
			'Ottobre',
			'Novembre',
			'Dicembre',
		],
		monthNamesShort: [
			'Gen',
			'Feb',
			'Mar',
			'Apr',
			'Mag',
			'Giu',
			'Lug',
			'Ago',
			'Set',
			'Ott',
			'Nov',
			'Dic',
		],
		dayNames: [
			'Domenica',
			'Lunedì',
			'Martedì',
			'Mercoledì',
			'Giovedì',
			'Venerdì',
			'Sabato',
		],
		dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
		dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
	}
	$.datepicker.regional['ca'] = {
		monthNames: [
			'Gener',
			'Febrer',
			'Març',
			'Abril',
			'Maig',
			'Juny',
			'Juliol',
			'Agost',
			'Setembre',
			'Octubre',
			'Novembre',
			'Desembre',
		],
		monthNamesShort: [
			'Gen',
			'Feb',
			'Mar',
			'Abr',
			'Mai',
			'Giu',
			'Jun',
			'Jul',
			'Set',
			'Oct',
			'Nov',
			'Dis',
		],
		dayNames: [
			'Diumenge',
			'Dilluns',
			'Dimarts',
			'Dimecres',
			'Dijous',
			'Divendres',
			'Dissabte',
		],
		dayNamesShort: ['Diu', 'Dil', 'Dim', 'Dim', 'Dij', 'Div', 'Dis'],
		dayNamesMin: ['Diu', 'Dil', 'Dim', 'Dim', 'Dij', 'Div', 'Dis'],
	}
	if ($('body').hasClass('langes')) {
		$.datepicker.setDefaults($.datepicker.regional['es'])
	}
	if ($('body').hasClass('langfr')) {
		$.datepicker.setDefaults($.datepicker.regional['fr'])
	}
	if ($('body').hasClass('langpt')) {
		$.datepicker.setDefaults($.datepicker.regional['pt'])
	}
	if ($('body').hasClass('langnl')) {
		$.datepicker.setDefaults($.datepicker.regional['nl'])
	}
	if ($('body').hasClass('langit')) {
		$.datepicker.setDefaults($.datepicker.regional['it'])
	}
	if ($('body').hasClass('langca')) {
		$.datepicker.setDefaults($.datepicker.regional['ca'])
	}

	/*****************************************************
    		GET WEATHER INFO FROM API
    /*****************************************************/
	if (!window.ActiveXObject && 'ActiveXObject' in window) {
		//explorer
	} else {
		if (document.getElementById('weather-container')) {
			let weather_container = document.getElementById('weather-container')
			let weather_grades = document.getElementById('js-weather-grades')
			let weather_main = document.getElementById('js-weather-main')
			let weather_wind = document.getElementById('js-weather-wind')
			let weather_humidity = document.getElementById('js-weather-humidity')
			fetch(
				'https://api.openweathermap.org/data/2.5/weather?q=Napa,us&APPID=0ddd1af8b5b1833cedd6da7a90934cce&units=imperial',
			)
				.then(function (response) {
					return response.json()
				})
				.then(function (myJson) {
					weather_grades.innerHTML =
						'<p>' + parseInt(myJson.main.temp) + '<sup>°F</sup></p>'
					weather_main.innerHTML =
						'<p>' + myJson.weather[0].description + '</p>'
					weather_wind.innerHTML =
						'<p>' + parseInt(myJson.wind.speed) + '<sup>mph</sup></p>'
					weather_humidity.innerHTML =
						'<p>' + parseInt(myJson.main.humidity) + '<sup>%</sup></p>'
				})
		}
	}

	$('.toTop').click(function () {
		$('html, body').animate({ scrollTop: 0 }, 1000)
	})

	$('.search-form form').on('submit', function () {
		document.location = '/results?q=' + $('.search-form input[type=text]').val()
	})

	// Listenerswith debounce function integrated
	const listener = (state = {}) => {
		if (state.target !== null)
			return state.target.addEventListener(
				state.event,
				debounce(state.func, 100),
			)
	}

	const booking = {
		triggerBtn: document.querySelector('.js-triggerBooking'),
		closeBtn: document.querySelector('.js-closeBooking'),
		triggerBtn2: document.querySelector('.js-booking2Open'),

		close(ev) {
			ev.preventDefault()
			$('.booking-container').removeClass('booking--open')
			$('.booking-background').remove()
		},

		open(ev) {
			ev.preventDefault()
			document
				.querySelector('.booking-container')
				.classList.add('booking--open')
			document
				.querySelector('.start-content')
				.insertAdjacentHTML(
					'afterbegin',
					'<div class="booking-background"></div>',
				)

			window.addEventListener('scroll', () =>
				window.scrollTo(ev.offsetX, window.scrollY),
			)

			$('.custom-gallery__slider').slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				dots: false,
				arrow: true,
				fade: true,
			});
		},

		open2(ev) {
			ev.preventDefault()
			if (ev.target.classList.contains('active')) {
				$('.booking2__inner').slideUp('fast', () => {
					$('.js-booking2Open').removeClass('active')
				})
			} else {
				$('.booking2__inner').slideDown('fast', () => {
					$('.js-booking2Open').addClass('active')
				})
			}
		},

		load() {
			bookingContainer.classList.add('loaded')
		},
	}

	function msieversion() {
		var ua = window.navigator.userAgent
		var msie = ua.indexOf('MSIE ')
		if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
			const image_fit = document.getElementsByClassName('accordion__image')
			for (let i = 0; i < image_fit.length; i++) {
				const this_image = image_fit[i].getElementsByTagName('img')[0]
				const image_src = this_image.getAttribute('src')
				image_fit[i].classList.add('ie-bg')
				image_fit[i].style.backgroundImage = 'url("' + image_src + '")'
			}
		} else {
			console.log('other browser')
		}

		return false
	}

	function _get_form_token(){
        $.get(
            site_url + '/ajax/functions.php?operation=_get_form_token',
            function(resp) {
                $("input[name=_token][type=hidden]").each( function(){
                    this.value = resp
                })		
            }		
        );
    }

	$(document).ready(function () {
		msieversion()
		_get_form_token()

		$('.search-header__button').click(function () {
			$(this).parent().addClass('open')
		})
		$('.search-header__close').click(function () {
			$(this).parent().removeClass('open')
		})

		$('.fancybox_iframe').fancybox({
			type: 'iframe',
			titleShow: false,
			padding: 0,
			fitToView: false,
			autoSize: false,
			width: 800,
			height: 450,
		})

		if (document.querySelector('.kids-content')) {
			var html = document.querySelector('.kids-content').innerHTML

			document.getElementById('addKid').addEventListener('click', function () {
				if (sub <= 4) {
					sub++

					var html_aux = html
					for (var i = 0; i <= 37; i++) {
						html_aux = html_aux.replace('_' + (sub - 1), '_' + sub)
					}

					document
						.getElementById('kids-content-general')
						.insertAdjacentHTML(
							'beforeend',
							"<div class='kids-content'><br><hr><div class='btn' onclick='sub--;document.getElementById( \"addKid\" ).style.display = \"inline-block\";$(this).parent().remove();'>Remove this</div><br><br>" +
								html_aux +
								'</div>',
						)
					html = html_aux
				}
				if (sub == 5) {
					document.getElementById('addKid').style.display = 'none'
				}

				return false
			})
		}

		/********************************************************************************
		 * HERO DATA LAYET - TRACKING
		 ********************************************************************************/
		$('.hero-tracking').click(function (event) {
			var selectedHero = $(this).attr('data-title')
			dataLayer.push({ section: 'hero', title: selectedHero })
		})

		/********************************************************************************
		 * SET LANGUAGE
		 ********************************************************************************/
		const $language_option = document.querySelector('select#select_language')

		if ($language_option !== null) {
			$language_option.addEventListener('change', (event) => {
				//GET INFO OF SELECTED OPTION
				let lang_abbr =
					event.target.value !== undefined ? event.target.value : 'en'
				// let lang = $language_option.options[$language_option.selectedIndex].text !== undefined ? $language_option.options[$language_option.selectedIndex].text : "English";

				//TRACK LANGUAGE CHANGE
				//if (typeof ga === 'function') ga('send', 'event', 'language change', "click", lang);

				//CHANGE LANGUAGE
				changeLanguage(lang_abbr)
			})
		}

		if (
			window.location.hash !== '' &&
			window.location.hash.includes('#') &&
			$('#list').length == 0
		) {
			setTimeout(function () {
				$('html,body').animate(
					{
						scrollTop:
							$(window.location.hash).offset().top - $('#header').height(),
					},
					'slow',
				)
			}, 1000)
		}

		const paragraph = document.querySelectorAll('p') || []
		paragraph.forEach(
			(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
		)

		$('.arrow-home').click(function (ev) {
			$('body, html').animate(
				{
					scrollTop: $(window).height() - $('header').outerHeight() * 2,
				},
				800,
				'easeOutExpo',
			)
		})

		$('.meeting-proposal').on('click', function () {
			if (typeof ga === 'function')
				ga('send', 'event', 'reservations', 'click', 'meeting-proposal')
		})

		// BOOOKING EVENTS!
		listener({ target: booking.triggerBtn, event: 'click', func: booking.open })
		listener({ target: booking.closeBtn, event: 'click', func: booking.close })
		listener({
			target: booking.triggerBtn2,
			event: 'click',
			func: booking.open2,
		})

		document
			.querySelectorAll(
				'.quad',
			)
			.forEach((e) =>
				listener({
					target: e,
					event: 'mouseover',
					func: () => e.classList.add('hover'),
				}),
			)

			document.querySelectorAll('.quad').forEach((e) =>
			listener({
				target: e,
				event: 'mouseout',
				func: () => e.classList.remove('hover'),
			}),
		)
		document
			.querySelectorAll(
				'#primary-nav ul li[class^=primary-nav-]:not([class^=primary-nav-sub])',
			)
			.forEach((e) =>
				listener({
					target: e,
					event: 'mouseover',
					func: () => e.classList.add('hover'),
				}),
			)

		document.querySelectorAll('#primary-nav ul li').forEach((e) =>
			listener({
				target: e,
				event: 'mouseout',
				func: () => e.classList.remove('hover'),
			}),
		)

		$('.sym-slides').slick()


		$('.gallery-slides').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		})
		$('.center-gallery-slides').slick({
			centerMode: true,
			centerPadding: '90px',
			slidesToShow: 3,
			slideToScroll: 1, 
			infinite: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		})

		$('.single-quad__slider').slick({
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			speed: 700,
		})
		
	// 	$('.slider-bg-start').slick({
	// 	prevArrow: prevArrow,
	// 	nextArrow: nextArrow,
	// 	fade: true,
	// 	slidesToShow: 1,
	// 	accessibility: true,
	// 	responsive: [
	// 		{
	// 			breakpoint: 1023,
	// 			settings: {
	// 				arrows: true,
	// 			}
	// 		}
	// 	]
	// })

		$('.local-attractions__slider').slick({
			arrows: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			speed: 700,
		})

		$('.multiple-items').slick({
			arrows: true,
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			adaptativeHeight:true
		})

		$('.separate-slider').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			fade: true,
			asNavFor: '.separate-slider-cntn',
		})

		$('.separate-slider-cntn').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.separate-slider',
			dots: false,
			fade: true,
			focusOnSelect: true,
		})

		$('.responsive').slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 4,
			fade: true,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					},
				},
			],
		})

		const acc_btns = document.querySelectorAll('.banquet-accordion__button')
		const acc_items = document.querySelectorAll('.banquet-accordion__item')
		if (acc_btns) {
			for (let i = 0; i < acc_btns.length; i++) {
				acc_btns[i].addEventListener('click', function () {
					if (
						this.closest('.banquet-accordion__item').classList.contains(
							'active',
						)
					) {
						this.closest('.banquet-accordion__item').classList.remove('active')
					} else {
						for (let a = 0; a < acc_items.length; a++) {
							acc_items[a].classList.remove('active')
						}
						this.closest('.banquet-accordion__item').classList.add('active')
					}
				})
			}
		}

		$('.breakfast__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.breakfast__item').hide()
			$('.breakfast__description').hide()
			$('.breakfast__item.' + tag).fadeIn()
			$('.breakfast__description.' + tag).fadeIn()
			$('.breakfast__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.breakfast__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.breakfast__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.breakfast__filter ul li')
			filter_tab[4].click()
		}

		$('.break__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.break__item').hide()
			$('.break__description').hide()
			$('.break__item.' + tag).fadeIn()
			$('.break__description.' + tag).fadeIn()
			$('.break__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.break__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.break__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.break__filter ul li')
			filter_tab[0].click()
		}

		$('.lunch__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.lunch__item').hide()
			$('.lunch__description').hide()
			$('.lunch__item.' + tag).fadeIn()
			$('.lunch__description.' + tag).fadeIn()
			$('.lunch__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.lunch__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.lunch__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.lunch__filter ul li')
			filter_tab[2].click()
		}

		$('.reception__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.reception__item').hide()
			$('.reception__description').hide()
			$('.reception__item.' + tag).fadeIn()
			$('.reception__description.' + tag).fadeIn()
			$('.reception__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.reception__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.reception__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.reception__filter ul li')
			filter_tab[0].click()
		}

		$('.dinner__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.dinner__item').hide()
			$('.dinner__description').hide()
			$('.dinner__item.' + tag).fadeIn()
			$('.dinner__description.' + tag).fadeIn()
			$('.dinner__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.dinner__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.dinner__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.dinner__filter ul li')
			filter_tab[0].click()
		}

		$('.after__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.after__item').hide()
			$('.after__description').hide()
			$('.after__item.' + tag).fadeIn()
			$('.after__description.' + tag).fadeIn()
			$('.after__filter ul li').removeClass('active')
			$(this).addClass('active')
			$.each($('.after__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.after__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.after__filter ul li')
			filter_tab[0].click()
		}

		$('.policies__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.policies__item').hide()
			$('.policies__description').hide()
			$('.policies__item.' + tag).fadeIn()
			$('.policies__description.' + tag).fadeIn()
			$('.policies__filter ul li').removeClass('active')
			$(this).addClass('active')
			console.log
			$.each($('.policies__item.' + tag), function (index, value) {
				if (index % 2 == 0) {
					$(this).addClass('left')
				} else {
					$(this).addClass('right')
				}
			})
		})

		if (
			$('#banquet-menus').length > 0 &&
			$('.policies__filter ul li').length > 0
		) {
			const filter_tab = document.querySelectorAll('.policies__filter ul li')
			filter_tab[0].click()
		}

		$('.banquet-menus__filter ul li').click(function () {
			const tag = $(this).attr('data-tag')
			$('.banquet-menus__container').hide()
			$('.banquet-menus__container.' + tag).fadeIn()
			$('.banquet-menus__filter ul li').removeClass('active')
			$(this).addClass('active')
		})

		if ($('#banquet-menus').length > 0) {
			const filter_tab_menu = document.querySelectorAll(
				'.banquet-menus__filter ul li',
			)
			filter_tab_menu[0].click()
		}

		// $("#CheckIn").datepicker({
		// 	numberOfMonths: 1,
		// 	dateFormat: date_format,
		// 	minDate: 0,
		// 	onSelect: function (selectedDate) {
		// 		let getDate = $(this).datepicker('getDate');
		// 		let newDate = new Date(getDate.getTime());
		// 		newDate.setDate(newDate.getDate() + 1);
		// 		$("#CheckOut").datepicker("setDate", newDate);
		// 		$("#CheckOut").datepicker("option", "minDate", selectedDate);
		// 	},
		// 	onClose: () => $("#CheckOut").datepicker('show')
		// });

		// $("#CheckOut").datepicker({
		// 	changeMonth: true,
		// 	dateFormat: date_format,
		// 	numberOfMonths: 1
		// });

		// $('.tracking-meeting').on('click', function () {
		// 	if (typeof ga == 'function') ga('send', 'event', 'button proposal', 'click', 'meeting-proposal');
		// });

		// if (typeof booking_lang !== 'undefined' && $('body').hasClass('has-language')) {
		// 	appendLang();
		// }

		setTimeout(function () {
			$('#start-content').addClass('start-content--visible')
			equalize()
			//$(window).scroll(debounce(scrollDown,200));
		}, 100)
		$(window).scroll(function (event) {
			scrollDown()
		})

		$('.open-video').click(function (event) {
			event.preventDefault()
		})
		$('.open-video').fancybox({
			afterShow: function () {
				$('#lightbox-video')[0].play()
			},
			overlayShow: true,
			centerOnScroll: true,
			speedIn: 100,
			speedOut: 50,
			allowfullscreen: true,
			width: '100%',
			height: '100%',
			autosize: false,
		})

		var videoUrl
		var smallVideo
		$('.open-video2').click(function (event) {
			event.preventDefault()
			videoUrl = $(this).attr('data-video')
			smallVideo = $(this).attr('data-small')
		})
		$('.open-video2').fancybox({
			afterShow: function () {
				$('#lightbox-video').attr('src', videoUrl)
				$('#lightbox-video')[0].play()
			},
			beforeShow: function () {
				console.log(smallVideo)
				if (smallVideo) {
					$('#lightbox-video').addClass('small-video')
					$('.lightbox-video-content').addClass('container-small-video')
				}
			},
			overlayShow: true,
			centerOnScroll: true,
			speedIn: 100,
			speedOut: 50,
			allowfullscreen: true,
			width: '100%',
			height: '100%',
			autosize: false,
		})
		$('.js-video').fancybox({
			wrapCSS: 'video-fancy',
			afterShow: function () {
				let vid = document.querySelector('.video-fancy video')
				vid.play()
				$('.video-fancy .fancybox-close').on('click', function () {
					vid.pause()
				})
			},
		})

		function scrollDown() {
			let top = $(document).scrollTop()

			if ($('#start-content.never-close').length == 0) {
				if (top > 0) {
					$('.booking2__inner').slideUp('fast', function () {
						$('.booking2').addClass('booking2-close')
					})
				} else {
					$('.booking2__inner').slideDown('fast', function () {
						$('.booking2').removeClass('booking2-close')
					})
				}
			}
		}

		// $('.js-booking2Open').click(function(ev){
		// 	ev.preventDefault();
		// 	$('.booking2__inner').slideDown('fast',function(){
		// 		$('.js-booking2Open').addClass('active');
		// 	})
		// })

		$('.general-button').click(function (ev) {
			$('.filter li').removeClass('border')
			ev.target.classList.add('border')
		})

		// ONLY FOR GALLERY
		if ($('#gallery-slider').length > 0) {
			var filter_selected = $('.filter li:first-child').data('filter')
			var seo_selected = document.getElementById('gallery-slider').dataset.seo
			var gallery_slider_send = { filter_selected, seo_selected }

			//postItems(gallery_slider_send);

			$('.general-button').click(function (ev) {
				$('.filter li').removeClass('border')
				ev.target.classList.add('border')
				filter_selected = ev.target.dataset.filter
				gallery_slider_send = { filter_selected, seo_selected }
				postItems(gallery_slider_send)
			})

			function postItems(data) {
				$.post(
					site_url + 'ajax/gallery-slider.php',
					data,
					function (data) {
						function showGallery(func) {
							$('#gallery-slider').html(data)
							func()
						}
						showGallery(function () {
							$('.gallery-slides').slick({
								infinite: true,
								slidesToShow: 3,
								slidesToScroll: 3,
							})
						})
					},
					'html',
				)
			}
		}

		// ONLY FOR SPECIALS / ROOMS
		if ($('#list').length > 0) {
			var first = $('.general-filter li.active')
			var page_selected = first.data('page')
			var tag_selected = first.data('tag')
			var site_location = first.data('id')
			var rooms_send = { page_selected, tag_selected, site_location }

			postItems(rooms_send)

			$('.general-filter li').click(function (ev) {
				$('.general-filter li').removeClass('active')
				ev.target.classList.add('active')
				var d = ev.target.dataset
				page_selected = d.page
				tag_selected = d.tag
				site_location = d.id
				rooms_send = { page_selected, tag_selected, site_location }
				postItems(rooms_send)
			})

			function postItems(data, func) {
				$.post(
					site_url + 'ajax/rooms-specials-list.php',
					data,
					function (data) {
						$('#list').html(data)
					},
					'html',
				).done(function (data) {
					setTimeout(function () {
						equalize()
						if (
							typeof booking_lang !== 'undefined' &&
							$('body').hasClass('has-language')
						) {
							appendLang()
						}
						if (window.location.hash) {
							var valScroll = $(window).scrollTop()
							setTimeout(function () {
								var hash = window.location.hash
								console.log(hashTop)
								var hashTop = $(hash).offset().top
								//$('html,body').scrollTop(hashTop-150)
								$('html,body').animate({ scrollTop: hashTop - 100 }, 1000)
							}, 0)
						}
					}, 200)
					$('.sym-slides').slick()
					$('html,body').animate(
						{
							scrollTop:
								$(window.location.hash).offset().top - $('#header').height(),
						},
						'slow',
					)
				})
			}

			/* if(page_id == 15977){
                let selectorMatch = `.rooms-filter li[data-filter="self-catering-accommodations"]`;
                setTimeout(function(){
                    $(selectorMatch).click(); 
                },100)
            } */
			var data_filter = location.hash.replace('#', '')
			let selectorMatch = `.rooms-filter li[data-filter="${data_filter}"]`
			$(selectorMatch).click()
		}

		//Map changes for Aspen
		if ($('body.wyndham-648.map').length > 0) {
			$('#attractions-entertainment').html('Aspen')
			$('#hotel').html('Aspen Meadows Resort')
		}

		$('.accordion__btn').click(function () {
			if ($(this).siblings('.accordion__content').is(':hidden')) {
				$('.accordion__content').slideUp()
				$(this).siblings('.accordion__content').slideDown()
				$('.accordion__btn').removeClass('open')
				$(this).addClass('open')
			} else {
				$(this).siblings('.accordion__content').slideUp()
				$(this).removeClass('open')
			}
		})

		// * animation scroll to hash

		let elements = document.querySelectorAll('.animate-scroll-to-hash')

		elements.forEach((element) => {
			element.addEventListener('click', function (event) {
                event.preventDefault();
                let onHash = this.getAttribute('href');
				let target = document.querySelector(onHash)

				if (target === null) return

				$('html,body').animate(
					{
						scrollTop:
							$(target).offset().top - $('#header').height() - 100,
					},
					'slow',
				)
			})
		})
	})

	$('.golf-filter li').click(function () {
		const this_tag = $(this).attr('data-tag')
		$('.golf-courses__col').removeClass('active')
		$('.golf-courses__col.' + this_tag).addClass('active')
		$('.golf-filter li').removeClass('active')
		$(this).addClass('active')
	})

	function appendLang() {
		$('.modify-reservation').each(function () {
			var $this = $(this)
			var _href = $this.attr('href')
			$this.attr('href', _href + '&locale=' + booking_lang)
		})
	}

	// function addAdaButton(){
	// 	document.getElementById('content').insertAdjacentHTML('beforeend',
	// 		'<a class="btn ada-map-button" href="/ada-map">Accessibility Map</a>');
	// }

	$('.datepicker-615').datepicker({
		dateFormat: 'mm/dd/yy',
		minDate: '01/01/2022',
	})
	
	if (document.getElementById('footer') != null) {
		var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
		submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
	}
	
	if (document.getElementById('form_id-2961')) {
		var submitSignUp = document.getElementById("form_id-2961").getElementsByClassName("btn")[0];
		submitSignUp.setAttribute('aria-label', 'submit contact us form');
	}
	
})()

function debounce(func, wait, immediate) {
	var timeout
	return function (...args) {
		const context = this

		const later = function () {
			timeout = null
			if (!immediate) func.apply(context, args)
		}

		var callNow = immediate && !timeout
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
		if (callNow) func.apply(context, args)
	}
}

$.urlParam = function (name) {
	var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
		window.location.href,
	)
	if (results == null) {
		return null
	} else {
		return decodeURI(results[1]) || 0
	}
}

//reveal hidden content
$('.revealText').click(function (e) {
	e.preventDefault()
	const $thisAm = $(this).closest('.parent').find('.son')

	if ($thisAm.is(':hidden')) {
		$(this).html('Less')
		$thisAm.slideDown()
	} else {
		$(this).html('View More')
		$thisAm.slideUp()
	}
})

/* Photos - custom */
var galleryexists = document.querySelector('#photos-custom')
if (galleryexists) {
	var elem = document.querySelector('.padding-half-TB.content__intro')
	elem.parentNode.removeChild(elem)
	galleryexists.parentNode.classList.remove('wrapper')
	var submenu = document.querySelector('.content__menu')
	submenu.parentNode.removeChild(submenu)
	document.querySelector('#content').classList.add('no-padding')
}

//MENU ACTIVITIES

// CREATE EMPTY TAGS LIST
let tagsList = []

// ADD TAG FROM ITEM TO TAGS LIST
document.querySelectorAll('.js-activities').forEach((item, i) => {
	tagsList.push(item.dataset.tag)
})

// CREATE HTML FROM TAGS LIST
const tagsList_HTML = `<ul class="tagslist">${tagsList
	.map((tag) => `<li>${tag}</li>`)
	.join('')}</ul>`

// ADD NEW HTML BEFORE 1ST ITEM
// document.querySelector('.itemclass').insertAdjacentHTML('beforebegin', tagsList_HTML);

// FANCYBOX VIDEO
$('.fancybox-video').fancybox({
	padding: 0,
	afterShow: function () {
		document.querySelector('.fancybox-inner .top-content-modal video').play()
	},
	beforeClose: function () {
		if(document.querySelector('.fancybox-inner .top-content-modal video')){
			document.querySelector('.fancybox-inner .top-content-modal video').pause()
			document.querySelector('.fancybox-inner .top-content-modal video').currentTime = 0
		}
	},
})

// ACCORDION TOGGLE
$('.faq-accordion_title').click(function () {
	$(this)
		.closest('.faq-accordion_list')
		.find('.faq-accordion_body')
		.stop()
		.slideUp('fast', function () {
			$(this).css('height', 'auto')
			$(this)
				.closest('.faq-accordion_item')
				.toggleClass('active', $(this).is(':visible'))
		})
	$(this)
		.next('.faq-accordion_body')
		.stop()
		.slideToggle('fast', function () {
			$(this).css('height', 'auto')
			$(this)
				.closest('.faq-accordion_item')
				.toggleClass('active', $(this).is(':visible'))
		})
})

//$(".things-to-do__list").first().find(".things-to-do__body").slideDown("fast").closest('.things-to-do__item').addClass("active");;
$('.things-to-do__item.active .things-to-do__body').slideDown('fast')
$('.things-to-do__title').click(function () {
	$(this)
		.closest('.things-to-do__right')
		.find('.things-to-do__body')
		.stop()
		.slideUp('fast', function () {
			$(this).css('height', 'auto')
			$(this)
				.closest('.things-to-do__item')
				.toggleClass('active', $(this).is(':visible'))
		})
	$(this)
		.next('.things-to-do__body')
		.stop()
		.slideToggle('fast', function () {
			$(this).css('height', 'auto')
			$(this)
				.closest('.things-to-do__item')
				.toggleClass('active', $(this).is(':visible'))
		})
})

setTimeout(function () {
	var currentUrl = window.location.search.substring(1)
	console.log(currentUrl)
	if (currentUrl != '') {
		var vars = currentUrl.split('&')
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split('=')
			if (pair[0] == 'specialFilter') {
				var filterSelected = document.querySelector(
					'.specials-filter li[data-filter="' + pair[1] + '"]',
				)
				if (filterSelected) {
					filterSelected.click()
				}
			}
			//var filterEl = document.getElementsByClassName();
		}
	}
}, 400)

window.onload = function () {}

// ACTIVITIES MENUS FILTER
document.querySelectorAll('.things-to-do__tags li').forEach((btn, i) => {
	btn.addEventListener('click', (_) => {
		document
			.querySelectorAll('.things-to-do__tags li')
			.forEach((b) => b.classList.remove('active'))
		btn.classList.add('active')

		document.querySelectorAll('.quad__list').forEach((activities) => {
			activities.classList.remove('active')
			if (
				activities.getAttribute('data-tag') &&
				activities
					.getAttribute('data-tag')
					.indexOf(btn.getAttribute('data-tag')) !== -1
			) {
				activities.classList.add('active')
			}
		})
	})

	if (i === 0) btn.click()
})

const acc_btns = document.querySelectorAll('.accordion-spa__button')
const acc_items = document.querySelectorAll('.accordion-spa__item')
if (acc_btns) {
	for (let i = 0; i < acc_btns.length; i++) {
		acc_btns[i].addEventListener('click', function () {
			if (this.closest('.accordion-spa__item').classList.contains('active')) {
				this.closest('.accordion-spa__item').classList.remove('active')
			} else {
				for (let a = 0; a < acc_items.length; a++) {
					acc_items[a].classList.remove('active')
				}
				this.closest('.accordion-spa__item').classList.add('active')
			}
		})
	}
}

if(document.querySelector("#hidden-form")){
	let inputOne = [...document.querySelectorAll("#hidden-form .field_3712_8 input")]
	let inputTwo = [...document.querySelectorAll("#hidden-form .field_3712_9 input")]
	
	inputOne.forEach( ( item, index ) => {
		item.addEventListener( "change", () => {
			inputTwo.forEach( ( i, j ) => {
				if(item.checked && i.checked){
					inputTwo.forEach( ( k ) => {
						k.checked = false
					})
				}
			} )
		} )
	})
	inputTwo.forEach( ( item ) => {
		item.addEventListener( "change", () => {
			inputOne.forEach( ( i ) => {
				if(item.checked && i.checked){
					inputOne.forEach( ( k ) => {
						k.checked = false
					})
				}
			} )
		} )
	})
}

/* READY */

window.addEventListener('DOMContentLoaded', function() {
	document.querySelectorAll(".fancybox").forEach(lightbox => {
		console.log(lightbox.getAttribute("href"));
		if (window.location.href.includes(lightbox.getAttribute("href"))) {
			setTimeout(() => {
				lightbox.click();
			}, 1000);
		}
	})
});

const btnEx = document.querySelector('.wyndham-657 .topalert__cta')
document.addEventListener('DOMContentLoaded', () => {

	btnEx && btnEx.removeAttribute('target')

	if (site_id == 615) {
		$('#booking-form .field.adults #adults').val('2').trigger('change')
	}
})

let MenuBox = document.getElementById('menu-box')
let JsMenu = document.getElementById('js-menu')
let CloseMenu = document.getElementById('close-menu')

if (document.getElementById('js-menu')) {
	//header click reserve
	JsMenu.addEventListener('click', function (e) {
		e.preventDefault()
		MenuBox.classList.add('open')
	})

	CloseMenu.addEventListener('click', function (e) {
		e.preventDefault()
		MenuBox.classList.remove('open')
	})
}
let bookingDateFormat = "yy-mm-dd"
/* if(project_id == 653) {
let bookingDateFormat = "mm/dd/yy";
} else {
let bookingDateFormat = "yy-mm-dd";
} */
let start,
	end,
	op = 0

const calendarBeforeShow = (date) => {
	if (start !== undefined) {
		let startDate = $.datepicker.parseDate(bookingDateFormat, start)
		let endDate = $.datepicker.parseDate(bookingDateFormat, end)
		if (date.getTime() == startDate.getTime()) {
			return [true, 'startday']
		} else {
			if (date.getTime() == endDate.getTime()) {
				return [true, 'endday']
			} else {
				if (
					date.getTime() > startDate.getTime() &&
					date.getTime() < endDate.getTime()
				) {
					return [true, 'days']
				} else {
					return [true]
				}
			}
		}
	} else {
		return [true]
	}
}

const calendarOnSelect = (date) => {
	start =
		start !== undefined
			? start
			: $.datepicker.formatDate(bookingDateFormat, new Date())
	let startDate = $.datepicker.parseDate(bookingDateFormat, start)
	let selectedDate = $.datepicker.parseDate(bookingDateFormat, date)

	if (op === 0) {
		op = 1
		start = date
		end = date
	} else {
		op = 0
		if (selectedDate <= startDate) {
			end = start
			start = date
		} else {
			end = date
		}
	}
	$('#checkin').val(start)
	$('#checkout').val(end)
}

const calendarOptions = {
	minDate: 0,
	numberOfMonths: 2,
	dateFormat: bookingDateFormat,
	beforeShowDay: calendarBeforeShow,
	onSelect: calendarOnSelect,
}

$('#dateCalendar').datepicker(calendarOptions)

if ($('.accordion').length > 0) {
	var data = document.URL
	if (data.indexOf('#') != -1) {
		data = data.split('#')[1]
		var top_ele = $('#' + data).offset().top
		$('html,body')
			.animate({ scrollTop: top_ele - 200 }, 1500)
			.delay(1000)
		setTimeout(() => {
			$('#' + data + ' .accordion__btn').click()
		}, 500)
	}
}

$('.items-featured__slider').slick({
	slidesToShow: 3,
	speed: 700,
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		}
	]
});

// EVENTS COLUMSN FILTER FUNCTIONALITY
const removeActiveClass = (items) => {
	for (let i = 0; i < items.length; i++) {
		items[i].classList.remove("active")
	}
}

const showTagEvents = (events, tag) => {

	events.forEach( event  => {
		if(tag == 'all') {
			
			event.classList.remove('hidden')
				
		} else if ( event.dataset.tag.toLowerCase() === tag.toLowerCase() ) {
			event.classList.remove('hidden')
		} else {
			event.classList.add('hidden')
		}

	});

	// for (let event1 of events) {
		
	// 	if(tag !== 'all') {
	// 		event1.dataset.tag !== tag ? event1.ssList.add("hidden") : event1.classList.remove("hidden")
	// 		event1.dataset.tag !== tag ? event1.claclassList.remove("visible") : event1.classList.add("visible")
	// 	} else {
	// 		event1.classList.remove("hidden")
	// 	}
	// }
}

const filterByCategory = (searched_value) => {
	let visible_items = document.querySelectorAll(`.events-content__item.visible`);
	visible_items.forEach((item) => {
		item.dataset.category !== searched_value ? item.classList.add("hidden") : item.classList.remove("hidden")
	})

}


if(document.querySelector(".events-columns-block")) {
	const filter_items = document.querySelectorAll(".events-columns-tags-filter .item");
	const events1 = document.querySelectorAll(".events-content__item");
	const categories_filter = document.getElementById("events-columns-categories")

	filter_items.forEach((item) => {
		item.addEventListener("click", () => {
			removeActiveClass(filter_items);
			item.classList.toggle("active");

			const tag = item.dataset.tag;

			showTagEvents(events1, tag);
		})
	})
	if(categories_filter) {
		categories_filter.addEventListener("change", () => {
			filterByCategory(categories_filter.value);
		})
	}

}
//PAGE SCROLL FUNCTIONALITY
function scrollElementByQuadParam(url) {
	const parsedURL = new URL(url);
	const quadValue = parsedURL.searchParams.get("quad");
 
	if (quadValue) {
		const elementToScroll = document.getElementById(quadValue);
 
		if (elementToScroll) {
			const scrollToPosition = elementToScroll.getBoundingClientRect().top - 100;
 
			// Scroll to the calculated position
			window.scrollTo({
				top: window.scrollY + scrollToPosition,
				behavior: "smooth"
			});
 
		} else {
			console.log("No element with the provided 'quad' parameter value was found.");
		}
	} else {
		console.log("The 'quad' parameter is not present in the URL.");
	}
 }

 (function () {
	if (document.getElementById('footer') != null) {
        var submitSignUp = document.getElementById("email-signup").getElementsByClassName("signup-btn ")[0];
        submitSignUp.setAttribute('aria-label', 'Subscribe to our email database');
    }


	if (document.querySelector('.wyndham-672.reservation-inquiry')) {
		let dateformStart = document.querySelector(".wyndham-672.reservation-inquiry #form_id-3357 input[name='arrival__check-in_']"); 
		let dateformEnd = document.querySelector(".wyndham-672.reservation-inquiry #form_id-3357 input[name='departure__check-out_']"); 
		dateformStart.addEventListener('change' , () => {
			dateformEnd._flatpickr.set("minDate", new Date(dateformStart.value));
		})
	}


 })()

 function updateLocationOnFormSubmit() {
	window.location.href = "https://www.iveyspencerleadershipcentre.com/reservation-inquiry-thank-you";
 }
 
 
 scrollElementByQuadParam( window.location.href );
//END EVENTS COLUMNS FILTER

// if($(".rooms-filter").length > 0){
//     $.each( $( ".rooms-filter li" ), function(index, li){
//         if( $(li).data( "filter" ) == data_filter ){
//             console.log(li,li.click());
//             $(li).click;
//         }
//     })
// }

//Hidden intro content with send a CMS form
if(document.querySelector('form.form-module button[type="submit"]') && document.querySelector('.content__intro__in')){
	const intervalForm = setInterval(() => {
		const formModule = document.querySelector('form.form-module');
		const styleAttribute = formModule.getAttribute('style');
		if (styleAttribute && styleAttribute.includes('display: none')) {
			clearInterval(intervalForm);
			const hiddenIntroContent = document.querySelector('.content__intro__in');
			if (hiddenIntroContent) {
				hiddenIntroContent.style.display = 'none';
			}
		}
	}, 1000);

}